export class AppFormatter {
  /**
   * Formata prêmio com separador de milhar
   */
  static formatPrize(prize: number): string {
    return new Intl.NumberFormat('pt-BR').format(prize);
  }

  /**
   * Calcula prêmio total das actions
   */
  static calculateTotalPrize(actions: Array<{ prize?: number }>): number {
    return actions.reduce((sum, action) => {
      return sum + (action.prize || 0);
    }, 0);
  }
}

